/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { type RootState } from '../rmsStore'

export default function getChargingStationReducer (state: RootState) {
  return state.chargingStationReducer
}
